import { cn } from '@/lib/utils';
import { Button } from '../button';

type PrimitiveTypes = string | number | boolean | null | undefined;
interface Item<T extends PrimitiveTypes> {
  label: string;
  value: T;
}

interface SelectorProps<T extends PrimitiveTypes> {
  items: ReadonlyArray<Item<T>>;
  onSelect: (item: Item<T>) => void;
  selectedValue: T | undefined;
  hasError?: boolean;
}

const Selector = <T extends PrimitiveTypes>({
  items,
  onSelect,
  selectedValue,
  hasError = false,
}: SelectorProps<T>) => {
  return (
    <div className="overflow-hidden w-full">
      <div className="overflow-x-scroll gap-2 lg:gap-4 flex [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        {items.map((item, index) => {
          const isSelected =
            selectedValue !== undefined && item.value === selectedValue;
          return (
            <Button
              key={index}
              aria-pressed={isSelected}
              size="small"
              variant={isSelected ? 'chipSelected' : 'chip'}
              className={cn(
                'text-center text-sm lg:text-base',
                'px-6 py-2 lg:px-8 lg:py-3',
                'h-9 lg:h-12',
                hasError &&
                  !isSelected && [
                    'border-status-danger',
                    index === 0 && 'md:border-r-0',
                  ]
              )}
              onClick={() => onSelect(item)}
            >
              {item.label}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

Selector.displayName = 'Selector';

export default Selector;
